interface FlashSaleProductQuantityProps {
  soldQuantity?: number
  totalQuantity?: number
  className?: string
}

const FlashSaleProductQuantity = ({
  soldQuantity,
  totalQuantity,
  className,
}: FlashSaleProductQuantityProps) => {
  const isSold = !!soldQuantity
  if (!totalQuantity) {
    return <div className={`h-[25px] ${className}`} />
  }

  return (
    <div
      className={`text-black relative h-[25px] rounded-full text-sm font-semibold ${
        !isSold ? 'bg-[#FFEFB4]' : 'bg-[#E4E4E4]'
      } ${className}`}
    >
      {isSold && (
        <div
          className='h-full rounded-full bg-[#FFEFB4]'
          style={{
            width: `${
              ((soldQuantity || totalQuantity) / totalQuantity) * 100
            }%`,
          }}
        />
      )}
      <span className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap'>
        {!isSold && 'Vừa mở bán'}
        {isSold && `Đã bán ${soldQuantity}/${totalQuantity} suất`}
      </span>
    </div>
  )
}

export default FlashSaleProductQuantity
